import React, { useState, useRef, useEffect } from 'react';
import { DisplayMode } from '../../@types/presentationView';
import zynthtext from '../../assets/zynth-text.png';
import SlideNarrative from '../inApp/SlideNarrative';
import CustomBuilderMenu from '../inApp/CustomBuilderMenu';
import Cover from '../inApp/Cover';
import Contact from '../inApp/Contact';
import Points from '../inApp/Points';
import People from '../inApp/People';
import Phases from '../inApp/Timeline';
import Images from '../inApp/Images';
import Table from '../inApp/Table';
import Graphs from '../inApp/Graphs';
import Statistics from '../inApp/Statistics';
import TextPlusImage from '../inApp/TextPlusImage';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';     
import Confetti from 'react-confetti';
import { useCredit } from '../../hooks/usecredit';
import { useDispatch, useSelector } from 'react-redux';
import { setZynthSlide } from '../../redux/slices/zynthSlideSlice';
import type { RootState } from '../../store'; 
import { useZynth } from '../../hooks/zynthSlide';
import ProgressSkeleton from '../skeletons/ProgressSkeleton';
import SlideOptionsSkeleton from '../skeletons/SlideOptionsSkeleton';

const RefinePPT: React.FC = () => {
  const [displayMode, setDisplayMode] = useState<DisplayMode>('slides');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [quickLoading, setQuickLoading] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
const triggerSourceRef = useRef<'newVersion' | 'addSlide' | null>(null);

  const slidesArrayRef = useRef<Record<string, any>>({});
  const [outlineId, setOutlineId] = useState<string>('');
  const [slideDataId, setSlideDataId] = useState<string>('');
  const [sectionName, setSectionName] = useState<string>('');
  const [formID, setFormID] = useState<string | null>(null);
  const [slideId, setSlideId] = useState<string | null>(null);
  const [slideType, setSlideType] = useState<string>('Points');
const [isZynthSlide, setIsZynthSlide] = useState(true);


const [progress, setProgress] = useState(0);
const [statusMsg, setStatusMsg] = useState("Preparing your slides...");
const [showProgress, setShowProgress] = useState(false);
const [showConfetti, setShowConfetti] = useState(false);
const progressRef = useRef<number>(0);



  const documentID = sessionStorage.getItem('documentID') || '';
  const orgID = sessionStorage.getItem('orgId') || '';
  const authToken = sessionStorage.getItem('authToken') || '';
  const navigate = useNavigate();
  
  const presentationId = sessionStorage.getItem('presentationId') || '1HvyxlmoGPi9Rol5RyYLHaVaboBE7ynrGUO5XbHkIF7s';
  const [planName, setPlanName] = useState("free");
  const clearSessionAndCloseModal = () => {
    sessionStorage.removeItem("outlineId");
    sessionStorage.removeItem("sectionName");
    window.parent.postMessage({ type: "closeRefineModal" }, "*");
  };
  const { credits, updateCredit, increaseCredit,decreaseCredit } = useCredit()
  const [isNew ,setIsNew]= useState(false)
  const isNewFlag = sessionStorage.getItem('isNewPresentation')
  const generateDocumentID = () => {
    return "Document-" + Date.now();
  };

  const handleAddCredit = () => {
    increaseCredit(5)
  }

  const handleDecreaseCredit = () => {
    decreaseCredit(5)
  }

  const handleUpgradeCredit=(val:number)=>{
      updateCredit(val)
  }

  const dispatch = useDispatch();
  const {
      zynthSlide,
      enableZynth,
      disableZynth,
      toggleZynth,
      setZynth
    } = useZynth();

  
  useEffect(()=>{
     const fetchCredits = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgID}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
       
        handleUpgradeCredit(res.data?.credits || 0);
        setPlanName(res.data?.plan?.plan_name || "free");
      } catch (err) {
        console.error("Failed to fetch credits:", err);
        handleUpgradeCredit(0);
        setPlanName("free");
      }
    };

    if (orgID && authToken) {
      fetchCredits();
    }
  },[])

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type === "openPptModal") {
        if (event.data.outlineId) {
          setOutlineId(event.data.outlineId);
          sessionStorage.setItem("outlineId", event.data.outlineId);
                triggerSourceRef.current = "addSlide";


        }
        if (event.data.sectionName) {
          setSectionName(event.data.sectionName);
          sessionStorage.setItem("sectionName", event.data.sectionName);
        }
        if(event.data.isNew){
          setIsNew(true)
          const newDocId = generateDocumentID();
          sessionStorage.setItem('newDocId',newDocId)
        }
        return;
      }

      if (event.data?.type === "slideId") {
        const receivedSlideId = event.data.slideId;
        setSlideId(receivedSlideId);
        triggerSourceRef.current = event.data.source || 'newVersion';

        try {
          const slideInfoResponse = await fetch("https://d2bwumaosaqsqc.cloudfront.net/api/v1/data/slidedisplay/get-slide-info", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${authToken}`,
            },
            body: JSON.stringify({ GenSlideID: receivedSlideId }),
          });

          const slideInfoData = await slideInfoResponse.json();
          console.log(zynthSlide)
          const isZynth = sessionStorage.getItem('isZynth');
          if ((!slideInfoData?.FormID || !slideInfoData?.slideData_id)  &&  (sessionStorage.getItem("isNewPresentation")=='false') && !zynthSlide && (!isZynth || isZynth === 'false') ) {
            setIsZynthSlide(false);
          toast.error('This is not a Zynth generated slide. Please use "Add new slide".');
            return;
          }
          setIsZynthSlide(true);
          setFormID(slideInfoData.FormID);
          setSlideDataId(slideInfoData.slideData_id);

          const storedTitle = sessionStorage.getItem("sectionName");
          if (!sectionName && storedTitle) {
            setSectionName(storedTitle);
          } else if (!sectionName) {
            setSectionName(slideInfoData.SectionName);
          }

          const storedOutline = sessionStorage.getItem("outlineId");
          if (!outlineId && storedOutline) {
            setOutlineId(storedOutline);
          } else if (!outlineId) {
            setOutlineId(slideInfoData.outline_id);
          }

          const slideTypeResponse = await fetch("https://d2bwumaosaqsqc.cloudfront.net/api/v1/data/slidedisplay/slide-type", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${authToken}`,
            },
            body: JSON.stringify({ slideData_id: slideInfoData.slideData_id }),
          });

          const slideTypeData = await slideTypeResponse.json();

if (slideTypeData?.slide_type) {
  setSlideType(slideTypeData.slide_type);

  // ❌ Don't override displayMode for addSlide flow
  if (triggerSourceRef.current !== "addSlide") {
    if (slideTypeData.slide_type === "Cover") {
      setDisplayMode("Cover");
    } else if (slideTypeData.slide_type === "Contact") {
      setDisplayMode("Contact");
    }
  }
      triggerSourceRef.current = null;

}


        } catch (error) {
          console.error("❌ slideId handler error:", error);
          toast.error("Failed to load slide data.");
        } finally {
          setLoading(false);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    const timeout = setTimeout(() => setLoading(false), 10000);

    return () => {
      window.removeEventListener("message", handleMessage);
      clearTimeout(timeout);
    };
  }, [authToken, sectionName, outlineId]);

  useEffect(() => {
    const savedSection = sessionStorage.getItem("sectionName");
    const savedOutline = sessionStorage.getItem("outlineId");

    if (savedSection && !sectionName) setSectionName(savedSection);
    if (savedOutline && !outlineId) setOutlineId(savedOutline);
  }, []);

  useEffect(() => {
    const checkTokenExpiry = () => {
      const token = sessionStorage.getItem("authToken");
      if (!token) return navigate("/login");

      try {
        const decoded: { exp?: number } = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);

        if (!decoded.exp || decoded.exp <= currentTime) {
          sessionStorage.clear();
          navigate("/login");
        } else {
          const timeoutDuration = (decoded.exp - currentTime) * 1000;
          setTimeout(() => {
            sessionStorage.clear();
            navigate("/login");
          }, timeoutDuration);
        }
      } catch (error) {
        console.error("Invalid token:", error);
        sessionStorage.clear();
        navigate("/login");
      }
    };

    checkTokenExpiry();
  }, [navigate]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

const startProgressPolling = (slideDataId: string) => {
  setShowProgress(true);
  setProgress(0);
  progressRef.current = 0;

  const interval = setInterval(async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/check-slide-progress-by-slideData`,
        {
          slideData_id: slideDataId, // ✅ use passed value
        },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      const apiProgress = data.progress || 0;

      if (progressRef.current < 50) {
        progressRef.current = Math.max(progressRef.current + 10, apiProgress);
      } else {
        progressRef.current = apiProgress;
      }

      setProgress(progressRef.current);

      if (progressRef.current >= 100) {
        clearInterval(interval);
        setStatusMsg("🎉 Slides are ready! Please close this screen to view them.");
        setShowConfetti(true);

        const latestId = data.latestGenSlideId || data.genSlideId || data.genSlideIds?.slice(-1)[0];

        if (latestId) {
          sessionStorage.setItem("genSlideIdToSelect", latestId);
          window.parent.postMessage(
            {
              type: "closeRefineModal",
              genSlideId: latestId,
            },
            "*"
          );
        } else {
          window.parent.postMessage({ type: "closeRefineModal" }, "*");
        }
      }
    } catch (err) {
      console.error("Progress polling failed:", err);
      setStatusMsg("Rechecking progress...");
    }
  }, 10000);
};



  const renderContent = () => {
    switch (displayMode) {
      case 'slides':
        return (
          <div className="flex flex-col justify-center bg-white shadow-lg rounded-lg  w-full h-[80vh] ">
             {quickLoading   ? (
              <div className="flex w-full h-full items-center justify-center">
                    {/* <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500" /> */}
                    <ProgressSkeleton />
              </div>
      
    ):
            <div className="flex flex-col items-center justify-center w-full h-full">
              <h2 className="text-xl font-bold text-gray-900 text-center">Create a new slide</h2>
              <p className="text-gray-600 mt-2 text-center text-xl">How would you like to create a new slide?</p>
              <div className="mt-6 flex flex-row justify-between gap-3 w-[80%] h-[12rem]">
                {[
                  {
                    name: 'Quick Generate',
                    icon: 'https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435466780_points.svg',
                    onClick: async () => {
                            if (!isZynthSlide && !(sessionStorage.getItem('presentationId'))) return;

                      try {
                     
                        setQuickLoading(true);
                        console.log("loader started",setQuickLoading)
                        const title = sectionName || 'Slide Title Here';
                        const payload={
                            type: slideType,
                            title,
                            documentID: formID||"Document-1747804129465",
                            outlineID: outlineId||"outlineID-9d59b5b2-b8f1-43b7-9ea6-ccb743fe1712",
                            presentationID: presentationId
                          }
                        const response = await axios.post(
                          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/${orgID}`,
                          payload,
                          {
                            headers: { Authorization: `Bearer ${authToken}` },
                          }
                        );
                        toast.success(`Slide Generation Started for ${title}`, {
                          position: 'top-right',
                          autoClose: 3000,
                        });
                         const slideDataID = response?.data?.data?.slideData_id;
                         setQuickLoading(false)
                          setSlideDataId(slideDataID)
                          setFormID(payload.documentID)
                          enableZynth()
                          sessionStorage.setItem('isZynth','true')
                        // startProgressPolling();
                         startProgressPolling(slideDataID);
                        // clearSessionAndCloseModal();
                      } catch (err) {
                        toast.error("Slide generation failed", {
                          position: 'top-right',
                          autoClose: 3000,
                        });
                      } finally {
                        setQuickLoading(false);
                      }
                    },
                      disabled: !isZynthSlide && (sessionStorage.getItem('isNewPresentation')=='false') && !zynthSlide,

                  },
                  {
                    name: 'Slide Narrative',
                    icon: 'https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435399743_Presentation.svg',
                    onClick: () => {
                            if ( !isZynthSlide && !isNew) return;

                      setDisplayMode('SlideNarrative');
                        // startProgressPolling(); // ✅ add this

                      // clearSessionAndCloseModal();
                    },
                        disabled:  !isZynthSlide && (sessionStorage.getItem('isNewPresentation')=='false' &&   !zynthSlide),

                  },
                  {
                    name: 'Custom Builder',
                    icon: 'https://d2zu6flr7wd65l.cloudfront.net/uploads/1739435517252_images.svg',
                    onClick: () => {
                            if ( !isZynthSlide && (sessionStorage.getItem('isNewPresentation')=='false')  && !zynthSlide) return;

                      setDisplayMode('customBuilder');
                        // startProgressPolling(); // ✅ add this
                      // clearSessionAndCloseModal();
                    },
                        disabled:  !isZynthSlide && !isNew,

                  },
                ].map((type) => (
                  // <button
                  //   key={type.name}
                  //   onClick={type.onClick}
                  //   disabled={quickLoading && type.name === 'quick'}
                  //   className="flex flex-col items-center bg-white shadow-md rounded-lg px-8 py-6 w-[30%] h-[100%] transition hover:shadow-lg border border-gray-200"
                  // >
                  //   <img src={type.icon} alt={type.name} className="w-16 h-16 mb-3" />
                  //   <span className="text-gray-900 font-medium text-center text-xl">
                  //     {quickLoading && type.name === 'Quick Generate' ? (
                  //       <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-blue-500" />
                  //     ) : (
                  //       type.name
                  //     )}
                  //   </span>
                  // </button>
                  <button
  key={type.name}
  onClick={isZynthSlide || (sessionStorage.getItem('isNewPresentation')=='true') ||  zynthSlide ? type.onClick : undefined}
  disabled={(!isZynthSlide  &&(sessionStorage.getItem('isNewPresentation')=='false') &&  !zynthSlide )|| (quickLoading && type.name === 'Quick Generate')}
  className={`flex flex-col items-center justify-center bg-white shadow-md rounded-lg px-8  w-[30%] h-[100%] transition hover:shadow-lg border border-gray-200 ${
    !isZynthSlide && (sessionStorage.getItem('isNewPresentation')=='false') ? 'opacity-50 cursor-not-allowed' : ''
  }`}
>
  <img src={type.icon} alt={type.name} className="w-16 h-16 mb-3" />
  <span className="text-gray-900 font-medium text-center text-xl">
    {quickLoading && type.name === 'Quick Generate' ? (
      <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-blue-500" />
    ) : (
      type.name
    )}
  </span>
</button>

                ))}
              </div>
            </div>
    }
          </div>
        );
  case 'Cover':
  return <Cover heading="Cover Slide" setDisplayMode={setDisplayMode} slideType="Cover" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || ''} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => {}} setFailed={() => {}} handleBack={() => setDisplayMode('slides')}  onSlideGenerated={startProgressPolling} />;

case 'Contact':
  return <Contact heading="Contact Slide" setDisplayMode={setDisplayMode} slideType="Contact" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || ''} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => {}} setFailed={() => {}} handleBack={() => setDisplayMode('slides')}   onSlideGenerated={startProgressPolling}/>;

      case 'Points':
        return <Points heading="Points Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }}   onSlideGenerated={startProgressPolling} />;
      case 'People':
        return <People heading="People Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }}   onSlideGenerated={startProgressPolling} userPlan={planName} />;
      case 'Timeline':
        return <Phases heading="Timeline Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }}   onSlideGenerated={startProgressPolling} />;
      case 'Images':
        return <Images heading="Images Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }}   onSlideGenerated={startProgressPolling} userPlan={planName}/>;
      case 'Table':
        return <Table heading="Table Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }}    onSlideGenerated={startProgressPolling} userPlan={planName}/>;
      case 'Graphs':
        return <Graphs heading="Graphs Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }}   onSlideGenerated={startProgressPolling} userPlan={planName} />;
      case 'TextandImage':
        return <TextPlusImage heading="Text + Image Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }}   onSlideGenerated={startProgressPolling}/>;
      case 'Statistics':
        return <Statistics heading="Statistics Slide" setDisplayMode={setDisplayMode} slideType="" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || sessionStorage.getItem('newDocId') || 'doc_123'} orgId={orgID} authToken={authToken} outlineID={outlineId} setIsSlideLoading={() => { }} setFailed={() => { }} onSlideGenerated={startProgressPolling}/>;
      case 'SlideNarrative':
        return <SlideNarrative heading={sectionName || 'Slide Title Here'} slideType="Points" documentID={ isNewFlag=='true'?sessionStorage.getItem('newDocId')||generateDocumentID() : formID || 'doc_123'} orgId={orgID} authToken={authToken} setDisplayMode={setDisplayMode} setIsSlideLoading={() => { }} outlineID={outlineId || 'abc123'} setFailed={() => { }} onSlideGenerated={startProgressPolling} userPlan={planName} />;
        case 'customBuilder':
  return <CustomBuilderMenu onTypeClick={setDisplayMode} setDisplayMode={setDisplayMode} />;

      default:
        return <CustomBuilderMenu onTypeClick={setDisplayMode} setDisplayMode={setDisplayMode}  />;
    }
  };

  return (
    <div className="flex flex-col items-center w-full min-h-screen bg-gray-100 p-2.5">
     

    {showProgress && (
<div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-70">
  {showConfetti && <Confetti recycle={false} numberOfPieces={300} />}
  <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md text-center relative">
    <button
      onClick={()=>setShowProgress(false)}
      className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
    >
      ×
    </button>
    <h2 className="text-xl font-semibold mb-4">Generating Slides...</h2>
    <div className="w-full bg-gray-200 rounded-full h-4">
      <div
        className="bg-green-500 h-4 rounded-full transition-all duration-500"
        style={{ width: `${progress}%` }}
      />
    </div>
    <p className="mt-4 text-gray-700">{statusMsg}</p>
    {progress >= 10 && (
      <button
        onClick={clearSessionAndCloseModal}
        className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        View Presentation
      </button>
    )}
  </div>
</div>

)}

      {/* <div className="w-full flex flex-col items-center text-center mb-6">
        <img src={zynthtext} alt="Zynth Logo" className="h-5 mb-2" />
        <h3 className="text-sm text-gray-700">AI Slides and Presentations</h3>
      </div> */}
      <div className="w-full py-2 border-b mb-6 text-gray-500 text-lg font-bold">{sectionName}</div>

      {loading ? (
        <div className="flex items-center justify-center w-full h-96">
          <SlideOptionsSkeleton />
        </div>
      ) : (
        renderContent()
      )}
    </div>

  );
};

export default RefinePPT;